import React, { Component } from 'react';
import Results from '../Results/Results.jsx';
import ResultsBiz from '../Results/ResultsBiz.jsx';
import ResultsBizLookAgain from '../Results/ResultsBizLookAgain.jsx';
import ResultsCHP from '../Results/ResultsCHP.jsx';
import ResultsEssential from '../Results/ResultsEssential.jsx';
import ResultsMedicaid from '../Results/ResultsMedicaid.jsx';
import ResultsMedicare from '../Results/ResultsMedicare.jsx';
import ResultsMedicareWesternNY from '../Results/ResultsMedicareWesternNY.jsx';
import * as QuizHelpers from '../../helpers/quiz';

import _ from 'lodash';

class Quote extends Component {
  state = {
    'resultsPages': {
      'Results': Results,
      'ResultsBiz': ResultsBiz,
      'ResultsCHP': ResultsCHP,
      'ResultsEssential': ResultsEssential,
      'ResultsMedicare': ResultsMedicare,
      'ResultsMedicaid': ResultsMedicaid,
      'ResultsMedicareWesternNY': ResultsMedicareWesternNY,
      'ResultsBizLookAgain': ResultsBizLookAgain
    },
    'loading': true
  };

  componentDidMount () {
    const p = _.clone(this.props);
    p.toggleInQuiz(false);
    p.toggleInResults(true);
    p.updateResultsFooter(true, {
      'jdpower': 'true'
    });
    p.updateResultsRatings(true, {
      'jdpower': 'true'
    });
  }

  static getDerivedStateFromProps (props, state) {
    const p = _.clone(props);
    const {
      subroute,
      updateZip,
      setFieldValue,
      rest
    } = p;
    const values = QuizHelpers.decodeUrl(subroute);
    const location = QuizHelpers._getCountyByZip(rest.counties, values.ZipCode);
    let newState = {};
    let loading = false;

    if (!_.isUndefined(location) && _.isUndefined(state['Location'])) {
      newState = {
        Location: location
      };
      loading = true;

      updateZip({ zip: values.ZipCode, county: location });
    }

    for (let key in values) {
      let value = values[key];
      if (_.isUndefined(state[key])) {
        if (_.isUndefined(value)) value = '';
        newState[key] = value;
        loading = true;
        setFieldValue(key, value);
      }
    }

    newState.loading = loading;

    return newState;
  }

  render () {
    const {ResultsType, resultsPages, loading} = _.clone(this.state);
    let View = resultsPages[ResultsType];
    const childViewProps = _.merge({}, _.clone(this.props), {reducer: this.props.postResults});
    return (_.isUndefined(ResultsType) || loading || _.isUndefined(View)) ?
      <div className={'dark loading'} /> : <View {...childViewProps} />;
  }
}

export default Quote;
